module.exports = __webpack_public_path__ + "img/bihua02.a6d892fa.png";